/** 反馈工单 WS 事件本地分发，供抽屉/客服台刷新未读与列表 */

export type FeedbackRealtimePayload = {
  event?: string
  ticketId?: string | number
  ticketNo?: string
  senderType?: string
  status?: string
  [key: string]: unknown
}

type Handler = (data: FeedbackRealtimePayload) => void

const handlers = new Set<Handler>()

export function onFeedbackRealtime(handler: Handler) {
  handlers.add(handler)
  return () => {
    handlers.delete(handler)
  }
}

export function emitFeedbackRealtime(data: FeedbackRealtimePayload | null | undefined) {
  if (!data) return
  handlers.forEach((handler) => {
    try {
      handler(data)
    } catch {
      // ignore listener errors
    }
  })
}
